var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEyeFilled = function SvgEyeFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 16,
    "data-width-20": 20,
    "data-width-26": 26,
    viewBox: "0 0 20 15",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.427 8.794C1.823 10.658 5.55 15 10 15s8.177-4.342 9.573-6.206A2.15 2.15 0 0 0 20 7.5a2.15 2.15 0 0 0-.427-1.294C18.177 4.342 14.467 0 10 0S1.823 4.37.427 6.206A2.15 2.15 0 0 0 0 7.5c0 .472.151.929.427 1.294M10 11.761a4.2 4.2 0 0 1-2.407-.76 4.5 4.5 0 0 1-1.596-2.026 4.7 4.7 0 0 1-.247-2.608c.167-.876.58-1.68 1.186-2.311A4.3 4.3 0 0 1 9.155 2.82a4.17 4.17 0 0 1 2.503.256c.792.342 1.469.92 1.945 1.663.476.742.73 1.615.73 2.508a4.6 4.6 0 0 1-1.269 3.192A4.25 4.25 0 0 1 10 11.762m0-7.725c-.61 0-1.206.188-1.713.541A3.2 3.2 0 0 0 7.151 6.02a3.34 3.34 0 0 0-.175 1.855c.119.623.413 1.196.844 1.645s.98.755 1.578.879 1.219.06 1.782-.183a3.1 3.1 0 0 0 1.384-1.183c.338-.528.52-1.15.52-1.784a3.28 3.28 0 0 0-.904-2.271A3.02 3.02 0 0 0 10 4.036",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEyeFilled);
export default ForwardRef;